import React, { CSSProperties } from 'react';
import { StylesConfig, OnChangeValue } from 'react-select';

import MSelect from 'views/MSelect/MSelect';

import { MReactSelectOption, MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';

type Props<Value, Id extends string, IsMulti extends boolean> = {
  className?: string;
  placeholder?: string;
  options: MSelectOption<Value, Id>[];
  isMulti?: IsMulti;
  heightOptions?: string;
  value?: IsMulti extends true
    ? (MSelectOption<Value, Id> | MSelectOption<Value, Id>['id'])[]
    : MSelectOption<Value, Id> | MSelectOption<Value, Id>['id'] | null;
  customStylesSelect?: StylesConfig<MReactSelectOption, IsMulti>;
  name?: string;
  valid?: boolean;
  disabledValueColor?: string;
  invalid?: boolean;
  hideSelectedOptions?: boolean;
  showSelected?: boolean;
  controlColor?: string;
  disabled?: boolean;
  hideEffectSelection?: boolean;
  isCreatable?: boolean;
  isClearable?: boolean;
  transparentBorder?: boolean;
  indicatorsContainerColor?: string;
  dropDownInputColor?: CSSProperties;
  onChange?: (value: OnChangeValue<MSelectChangeData<Value, Id>, IsMulti>) => void;
};

const MFormSelectView = <Value, Id extends string = string, IsMulti extends boolean = false>(
  props: Props<Value, Id, IsMulti>,
): JSX.Element => {
  return (
    <MSelect
      dropDownInputColor={props.dropDownInputColor}
      className={props.className}
      heightOptions={props.heightOptions}
      placeholder={props.placeholder}
      disabledValueColor={props.disabledValueColor}
      options={props.options}
      isMulti={props.isMulti}
      value={props.value}
      customStylesSelect={props.customStylesSelect}
      controlColor={props.controlColor}
      name={props.name}
      valid={props.valid}
      invalid={props.invalid}
      isClearable={props.isClearable}
      indicatorsContainerColor={props.indicatorsContainerColor}
      hideSelectedOptions={props.hideSelectedOptions}
      showSelected={props.showSelected}
      disabled={props.disabled}
      isCreatable={props.isCreatable}
      hideEffectSelection={props.hideEffectSelection}
      onChange={props.onChange}
      transparentBorder={props.transparentBorder}
    ></MSelect>
  );
};

MFormSelectView.displayName = 'MFormSelectView';
MFormSelectView.defaultProps = {};

export default MFormSelectView;
